<template>
  <div class="video-wrap">
    <div class="video-container">
      <xes-video :videoInfo="videoInfo"></xes-video>
    </div>
  </div>
</template>

<script>
import XesVideo from '@/common/components/video'
// import XesVideo from '@/common/components/videoFull'

export default {
  name: 'video',
  components: {
    'xes-video': XesVideo
  },
  data() {
    return {
      videoInfo: {
        id: 0,
        videoAddress: 'https://editor.xesimg.com/tailor/resource/summercamp-video-1627957224710.mp4', // 视频地址
        videoPoster: 'https://editor.xesimg.com/tailor/resource/poster-1622428852661.jpg',
        name: ''
      }
    }
  }
}
</script>

<style lang="less" scoped>
.video-wrap {
  width: 312px;
  height: 175px;
  margin: 26px/2 auto;

  .video-container {
    width: 312px;
    height: 175px;
    overflow: hidden;
    border-radius: 10px !important;
  }
}

</style>
<style lang="less">

  .video-container {
    .mask,
    .videoPoster,
    .video_no_wifi,
    .play_btn {
      overflow: hidden;
      border-radius: 10px !important;
    }

    .video {
      width: 312px;
      height: 175px;
      overflow: hidden;
      border-radius: 10px;

      video {
        background: transparent;
      }

      .videoPoster {
        z-index: 101;
      }

      .play_btn {
        z-index: 102;
        background-image: url('../assets/images/play-btn.png');
        background-size: 40px !important;
      }

      .mask {
        z-index: 102;
        background: #000;
        opacity: 0.1 !important;
      }
    }
  }

</style>
